var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyInfoImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 393.037,
    height: 207.223,
    viewBox: "0 0 393.037 207.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5812",
    "data-name": "Group 5812",
    transform: "translate(-12880 10157.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5695",
    "data-name": "Path 5695",
    d: "M11628,2231.944c-.083.809,0,207.211,0,207.211h393s-.038-117.741,0-117.787c-.539-.064-.19-89.441,0-89.423C12021,2231.918,11628,2231.944,11628,2231.944Z",
    transform: "translate(1252.037 -12388.934)",
    fill: "#0f43cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5697",
    "data-name": "Path 5697",
    d: "M12,0a12.223,12.223,0,0,1,6.009,1.61c0,17.774.007.514.007,20.83A12.418,12.418,0,0,1,12,24,12,12,0,0,1,12,0Z",
    transform: "translate(13255 -9987)",
    fill: "#058ee5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5696",
    "data-name": "Path 5696",
    d: "M41.5,0a41.5,41.5,0,0,1,0,83,42.9,42.9,0,0,1-10.469-1.356V1.269A44.1,44.1,0,0,1,41.5,0Z",
    transform: "translate(12849 -10149)",
    fill: "#058ee5",
    opacity: 0.47
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInfoImg);
export default __webpack_public_path__ + "static/media/companyInfoImg.58c0ab229453e9f0e8a1fbcdfbd0933a.svg";
export { ForwardRef as ReactComponent };